
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 800 800","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M166.667 166.667l466.666 466.666","stroke":"#fff","stroke-width":"66.667","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M266.762 230.57l-45.121 36.097h-88.308c-36.819 0-66.666 29.848-66.666 66.666v133.333c0 36.82 29.847 66.667 66.666 66.667h88.308l103.379 82.703c43.65 34.924 108.313 3.844 108.313-52.056V397.14l-66.666-66.665V563.98l-103.38-82.704a66.672 66.672 0 00-41.646-14.61h-88.308V333.333h88.308a66.669 66.669 0 0041.646-14.607l50.906-40.725-47.431-47.431zm99.905 5.624v-.172l-.097.076-47.429-47.43 5.879-4.704c43.65-34.921 108.313-3.843 108.313 52.058v66.839l-66.666-66.667zm143.956 238.239a133.137 133.137 0 01-8.483 11.274c-11.833 14.103-9.993 35.126 4.107 46.959 14.103 11.834 35.13 9.994 46.963-4.106 1.76-2.1 3.477-4.234 5.147-6.397l-47.734-47.73zm80.09-14.193l-57.41-57.41c.61-28.78-8.11-57.007-24.89-80.445-10.716-14.969-7.27-35.791 7.7-46.508 14.967-10.716 35.79-7.269 46.507 7.7a200.005 200.005 0 0128.093 176.663zm15.074 109.356c-.5.607-1.004 1.21-1.507 1.814-11.833 14.103-9.997 35.13 4.107 46.963 13.21 11.084 32.49 10.17 44.603-1.573l-47.203-47.204zm85.946-8.336l-49.58-49.58a266.667 266.667 0 00-35.5-280.22c-11.636-14.267-9.503-35.264 4.764-46.899 14.266-11.636 35.263-9.503 46.896 4.763a333.336 333.336 0 0133.42 371.936z","fill":"#fff"}})])
          )
        }
      }
    